import { API } from "../../../utils/Apis";
import {
  getAdminBookingList,
  getAdminPaymentsList,
  getCollectedList,
  getHistoryList,
  getPaidList,
  getRequestsList,
  getUserPaymentsList,
} from "../Reducers/BookingsReducer";
import { AppDispatch } from "../Store";

export const getUserPaymentsListAction = (
  data: object,
  dispatch: AppDispatch
) =>
  API.getUserPayments(data).then((res) => {
    if (res.type === "success") {
      dispatch(getUserPaymentsList({ items: res.data }));
    }

    return res;
  });

export const getPaidListAction = (data: object, dispatch: AppDispatch) =>
  API.getPaidBookings(data).then((res) => {
    if (res.type === "success") {
      dispatch(getPaidList({ items: res.data }));
    }

    return res;
  });

export const getCollectedListAction = (data: object, dispatch: AppDispatch) =>
  API.getCollectedBookings(data).then((res) => {
    if (res.type === "success") {
      dispatch(getCollectedList({ items: res.data }));
    }

    return res;
  });

export const getBookingReuestsAction = (data: object, dispatch: AppDispatch) =>
  API.getBookingRequests(data).then((res) => {
    if (res.type === "success") {
      dispatch(getRequestsList({ items: res.data }));
    }

    return res;
  });

export const getBookingHistoryAction = (data: object, dispatch: AppDispatch) =>
  API.getBookingHistory(data).then((res) => {
    if (res.type === "success") {
      dispatch(getHistoryList({ items: res.data }));
    }

    return res;
  });

export const getAdminPaymentsListAction = (
  data: object,
  dispatch: AppDispatch
) =>
  API.getAdminPayments(data).then((res) => {
    if (res.type === "success") {
      dispatch(getAdminPaymentsList({ items: res.data }));
    }

    return res;
  });

export const getAdminBookingListAction = (
  data: object,
  dispatch: AppDispatch
) =>
  API.getAdminBookingList(data).then((res) => {
    if (res.type === "success") {
      dispatch(getAdminBookingList({ items: res.data }));
    }

    return res;
  });

export const userCheckInAction = (data: object) => API.userCheckIn(data);
export const userCheckOutAction = (data: object) => API.userCheckOut(data);
export const hostCheckInAction = (data: object) => API.hostCheckIn(data);
export const hostCheckOutAction = (data: object) => API.hostCheckOut(data);
